import React from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import './PublicHome.css';
import './Contact.css';
import './About.css';

function About() {
  return (
    <div className="ph-root ct-page">
      <PublicHeader />

      <main className="ct-main ab-main">
        <header className="ct-hero">
          <p className="ph-eyebrow">Who we are</p>
          <h1 className="ct-title">About us</h1>
          <p className="ct-lead">
            ODUS helps landlords and tenants stay aligned—from first viewing to
            everyday living—with clear listings, simple tools, and responsive
            support.
          </p>
        </header>

        <section className="ab-section">
          <h2 className="ab-section-title">Our mission</h2>
          <p className="ab-section-text">
            We believe renting should feel straightforward. Our platform brings
            portfolio management, maintenance, and tenant communication together
            so property teams can focus on people, not paperwork.
          </p>
        </section>

        <section className="ab-section">
          <h2 className="ab-section-title">What we offer</h2>
          <ul className="ab-list">
            <li>Curated HMO and multi-let listings with transparent pricing</li>
            <li>Tools for owners to track properties, prospects, and operations</li>
            <li>A tenant portal for rent, maintenance, and feedback</li>
            <li>Support that aims to respond within one business day</li>
          </ul>
        </section>

        <section className="ab-values" aria-label="Our values">
          <h2 className="ab-section-title ab-section-title--center">Our values</h2>
          <div className="ab-value-grid">
            <article className="ab-value-card">
              <h3 className="ab-value-title">Clarity</h3>
              <p className="ab-value-text">
                Honest information on homes, costs, and next steps—no hidden
                surprises.
              </p>
            </article>
            <article className="ab-value-card">
              <h3 className="ab-value-title">Care</h3>
              <p className="ab-value-text">
                Homes matter. We treat every enquiry and issue with respect and
                urgency.
              </p>
            </article>
            <article className="ab-value-card">
              <h3 className="ab-value-title">Connection</h3>
              <p className="ab-value-text">
                Better outcomes when landlords, tenants, and staff work from one
                place.
              </p>
            </article>
          </div>
        </section>

        <section className="ab-cta">
          <p className="ab-cta-text">Want to work with us or list a property?</p>
          <div className="ab-cta-actions">
            <Link to="/contact" className="ph-btn ph-btn-primary ab-cta-btn">
              Contact us
            </Link>
            <Link to="/" className="ph-btn ph-btn-outline ab-cta-btn">
              Browse listings
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}

export default About;
